import React from 'react';
import { motion } from 'framer-motion';

const RevealText = ({ children, className }) => {
    return (
        <div className={`overflow-hidden ${className}`}>
            <motion.div
                initial={{ y: "100%" }}
                whileInView={{ y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
            >
                {children}
            </motion.div>
        </div>
    );
};

export default RevealText;
